import React, {useRef} from 'react';
import {useSelector} from 'react-redux';
import {useDetectOutsideClick} from './useDetectOutsideClick';
import ico_profile from '../../../assets/ico_profile.svg';
import ico_arrow from '../../../assets/ico_arrow_down_white.svg';
import {useHistory} from 'react-router';

const disable = false;

const HeaderProfile = ({ usuario }) => {
  const history = useHistory();
  const {user: { nombreLargo }} = useSelector((state) => state.auth);

  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const [isActiveMenu, setIsActiveMenu] = useDetectOutsideClick(dropdownRef, false);
  const onClick = () => setIsActive(!isActive);
  const onClickMenu = () => setIsActiveMenu(!isActiveMenu);
  const getActiveClassName = (is) => is ? 'active' : 'inactive';

  const handleClick = () => {
    history.push("/sign-out");
  };

  return (
    <div className="header-profile-container">
      <div className="header-profile-menuitem">

        {disable && (
          <>
            <button onClick={onClickMenu}>
              <span>Power Rimac</span>
              <img src={ico_arrow} className="header-profile__ico" alt="" />
            </button>
            <nav
              ref={dropdownRef}
              className={`header-profile-menu ${getActiveClassName(isActiveMenu)}`}
            >
              <ul>
                <li><a href="/planificacion">Planificación</a></li>
                <li><a href="/seguimiento">Seguimiento</a></li>
              </ul>
            </nav>
          </>
        )}
      </div>
      <button onClick={onClick} className="header-profile-trigger">
        <img
          src={ico_profile}
          alt={usuario}
          className="header-profile__ico"
        />
        <span>{nombreLargo} </span>
        <img src={ico_arrow} alt="" className="header-profile__ico" />
      </button>
      <nav
        ref={dropdownRef}
        className={`header-profile-menu ${getActiveClassName(isActive)}`}
      >
        <ul>
          <li onClick={handleClick}>Cerrar sesión</li>
        </ul>
      </nav>
    </div>
  );
};

export default HeaderProfile;
